import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BodyTextMedium, HeadingText40, pxToRem } from '@modernhealth/vital-components';
import { color } from 'src/shared/styles/variables';

import { CoachIntroWrapper } from 'src/modules/providers/components/CoachIntroWrapper';
import { CommonStepButtons } from '../components/CommonStepButtons';
import { OuterScreenWrapper, ScreenWrapper } from '../components/ScreenWrapper';
import { IntakeFormProps, IntakeFormTestID } from '../models/intakeForm';

const IntroTextWrapper = styled.div({
    width: pxToRem(540),
    margin: pxToRem(32),
    marginBottom: 0,
    padding: pxToRem(28),
    border: `2px solid ${color.catskillWhite}`,
    borderRadius: '0.4rem',
});

const ButtonsContainer = styled.div({
    width: pxToRem(540),
});

export const IntakeIntroScreen: React.FC<IntakeFormProps> = props => {
    const {
        coachAvatar,
        coachFirstName,
        coachLastName,
        coachCredentials,
        userFirstName,
        onAbandonClick,
        toggleCoachMoreInfo,
        skipQuestion,
    } = props;
    const { t } = useTranslation();

    return (
        <OuterScreenWrapper>
            <ScreenWrapper data-testid={IntakeFormTestID.IntroScreen} verticalCenter>
                <CoachIntroWrapper
                    withInfo
                    onInfoClick={toggleCoachMoreInfo}
                    coachAvatar={coachAvatar}
                    coachFirstName={coachFirstName}
                    coachLastName={coachLastName}
                    coachCredentials={coachCredentials}
                />
                <IntroTextWrapper>
                    <HeadingText40 marginBottom={24}>
                        {t('intakeForms:intro.greeting', { userFirstName })}
                    </HeadingText40>
                    <BodyTextMedium fontColor="gray65" marginBottom={24}>
                        {t('intakeForms:intro.im_your_coach', { coachFirstName })}
                    </BodyTextMedium>
                    <BodyTextMedium fontColor="gray65" marginBottom={24}>
                        {t('intakeForms:intro.set_up_for_success')}
                    </BodyTextMedium>
                    <BodyTextMedium fontColor="gray65" marginBottom={8}>
                        {t('intakeForms:intro.encourage_to_share')}
                    </BodyTextMedium>
                </IntroTextWrapper>
                <ButtonsContainer>
                    <CommonStepButtons
                        forwardText={t('intakeForms:intro.begin_form')}
                        backText={t('intakeForms:intro.complete_later')}
                        onForwardClick={skipQuestion}
                        onBackClick={() => onAbandonClick('')}
                    />
                </ButtonsContainer>
            </ScreenWrapper>{' '}
        </OuterScreenWrapper>
    );
};
